import { z } from 'zod';

export const useStepThreeValidation = () => {
	const problemSchema = z.object({
		execution: z.preprocess(
			(value) => (value === '' ? undefined : Number(value)),
			z.number({ required_error: 'Обязательное поле' }).min(1).max(10),
		),
		satisfaction: z.preprocess(
			(value) => (value === '' ? undefined : Number(value)),
			z.number({ required_error: 'Обязательное поле' }).min(1).max(10),
		),
		prefix: z.array(z.string()).optional(),
		domainCode: z.array(z.string()).optional(),
		stepType: z.string().optional(),
		shortTermGoals: z.array(z.object({
			resultScore: z.string().optional(),
		})).optional(),
	});

	const stepThreeSchema = z.object({
		problems: z.array(problemSchema),
		goal: z.string().min(1),
		goalPlan: z.string().optional(),
		scoreResult: z.string().optional(),
	});

	return { stepThreeSchema };
};
export type StepThreeInfo = z.input<ReturnType<typeof useStepThreeValidation>['stepThreeSchema']>;
